<template>
  <el-form-item :label="$t('keyword')">
    <el-input
      v-model="keyword"
      :placeholder="$t('enter_value')"
    ></el-input>
  </el-form-item>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    keyword: {
      get() {
        return this.value;
      },
      set(keyword) {
        this.$emit("input", keyword);
      },
    },
  },
};
</script>

<i18n>
{
  "en": {
    "keyword": "Keyword",
    "value": "Value",
    "enter_value": "Enter value"
  },
  "fr": {
    "keyword": "Mot clé",
    "value": "Valeur",
    "enter_value": "Entrez valeur"
  },
  "de": {
    "keyword": "Stichwort",
    "value": "Wert",
    "enter_value": "Wert eingeben"
  }
}
</i18n>
